export const SoundsOffSVG = (props) => (
  <svg
    width="800px"
    height="800px"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M6.4948 9.31065L13.1027 2.82973C14.91 1.05725 18 2.3126 18 4.81925V23.1808C18 25.6874 14.9099 26.9427 13.1027 25.1703L6.4948 18.6893H3.44375C2.0941 18.6893 1 17.6163 1 16.2926V11.7074C1 10.3837 2.0941 9.31065 3.44375 9.31065H6.4948ZM3.44375 11.3948C3.26771 11.3948 3.125 11.5348 3.125 11.7074V16.2926C3.125 16.4652 3.26771 16.6052 3.44375 16.6052H5.25V11.3948H3.44375ZM7.59284 16.8188C7.45336 16.682 7.375 16.4965 7.375 16.303V11.697C7.375 11.5035 7.45336 11.318 7.59284 11.1812L14.6053 4.30345C15.0739 3.84392 15.875 4.16938 15.875 4.81925V23.1808C15.875 23.8306 15.0739 24.1561 14.6053 23.6966L7.59284 16.8188Z"
      fill="#dcdfe1"
      fillRule="evenodd"
    />
    <path
      d="M20.7071 12.1212C20.3166 11.7306 20.3166 11.0975 20.7071 10.707C21.0976 10.3164 21.7308 10.3164 22.1213 10.707L23.8887 12.4743L25.656 10.707C26.0465 10.3164 26.6797 10.3164 27.0702 10.707C27.4608 11.0975 27.4608 11.7306 27.0702 12.1212L25.3029 13.8885L27.0711 15.6567C27.4616 16.0472 27.4616 16.6804 27.0711 17.0709C26.6805 17.4614 26.0474 17.4614 25.6569 17.0709L23.8887 15.3027L22.1205 17.0709C21.73 17.4614 21.0968 17.4614 20.7063 17.0709C20.3158 16.6804 20.3158 16.0472 20.7063 15.6567L22.4745 13.8885L20.7071 12.1212Z"
      fill="#dcdfe1"
    />
  </svg>
)
